enum SelectionDirectionEnum {
	forwards = 1,
	backwards = -1,
	directionless = 0
}

export default SelectionDirectionEnum;
